import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './fonts/font.css';
import authApi  from './api/index';

const ADMIN_URL = 'http://api.dantemoscow.ru/';

function initLangs(){
  let type = 'lex';
  // initReact(require('./lexicon/ru.json'),require('./lexicon/ru.json'));
  authApi.get(type)
    .then(response => {
      if(response.ok) {
        let clone = response.clone();
        return clone.json();
      } else {            
        return Promise.reject();
      }
    })
    .then(json => {
      if(json.error){
        console.log(json);
      } else {      
        // console.log(json.lex);
        // console.log(json.main);
        // console.log(json.contacts);
        // console.log(json.gallery);
        initReact(JSON.parse(json.lex.ru),JSON.parse(json.lex.en), json.main, json.contacts, json.gallery, JSON.parse(json.menu));
      }
    })
    .catch((e) => {
      console.error(e);
    })
}
initLangs();

function initReact(ru, en, main, contacts, gallery, menu){
  ReactDOM.render(
    <App ru={ru} en={en} main={main} contacts={contacts} gallery={gallery} menu={menu} ADMIN_URL={ADMIN_URL}/>, 
    document.getElementById('root')
  );
  registerServiceWorker();
}


// WEBPACK FOOTER //
// ./src/index.js